"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareButtons = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _appendQueryParams = require("../../utils/url/appendQueryParams");
var _FacebookFilled = require("../icons/FacebookFilled");
var _PinterestFilled = require("../icons/PinterestFilled");
var _WhatsappFilled = require("../icons/WhatsappFilled");
var _XFilled = require("../icons/XFilled");
var _ShareButtonsModule = _interopRequireDefault(require("./ShareButtons.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SocialShareButton = function SocialShareButton(_ref) {
  var href = _ref.href,
    anchorProps = _ref.anchorProps,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", _objectSpread(_objectSpread({
    href: href,
    rel: "noreferrer",
    target: "_blank"
  }, anchorProps), {}, {
    "data-jlds": true,
    onClick: onClick,
    children: icon
  }));
};
SocialShareButton.propTypes = {
  href: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func
};
var ShareButtons = exports.ShareButtons = function ShareButtons(_ref2) {
  var url = _ref2.url,
    title = _ref2.title,
    image = _ref2.image;
  var twitterUrl = encodeURIComponent((0, _appendQueryParams.appendQueryParamsToUrl)(url, 'tmad=c&tmcampid=7&s_share=w_twi'));
  var facebookUrl = encodeURIComponent((0, _appendQueryParams.appendQueryParamsToUrl)(url, 'tmad=c&tmcampid=7&s_share=w_fac'));
  var whatsappUrl = encodeURIComponent((0, _appendQueryParams.appendQueryParamsToUrl)(url, 'tmad=c&tmcampid=7&s_share=w_wha'));
  var pinterestUrl = encodeURIComponent((0, _appendQueryParams.appendQueryParamsToUrl)(url, 'tmad=c&tmcampid=7&s_share=w_pin'));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _ShareButtonsModule.default.shareLinks,
    "data-jlds": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SocialShareButton, {
      anchorProps: {
        className: _ShareButtonsModule.default.shareLinksItem,
        'data-testid': 'twitter-share-button'
      },
      href: "https://twitter.com/intent/tweet?url=".concat(twitterUrl, "&text=").concat(title),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_XFilled.XFilled, {
        size: "medium",
        title: "Share Via X"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialShareButton, {
      anchorProps: {
        className: _ShareButtonsModule.default.shareLinksItem,
        'data-testid': 'facebook-share-button'
      },
      href: "https://www.facebook.com/sharer/sharer.php?u=".concat(facebookUrl),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FacebookFilled.FacebookFilled, {
        size: "medium",
        title: "Share Via Facebook"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialShareButton, {
      anchorProps: {
        className: _ShareButtonsModule.default.shareLinksItem,
        'data-testid': 'pinterest-share-button'
      },
      href: "https://www.pinterest.com/pin/create/button/?url=".concat(pinterestUrl, "&media=").concat(image, "&description=").concat(title),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PinterestFilled.PinterestFilled, {
        size: "medium",
        title: "Share Via Pinterest"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialShareButton, {
      anchorProps: {
        className: _ShareButtonsModule.default.shareLinksItem,
        'data-testid': 'whatsapp-share-button'
      },
      href: "https://wa.me/?text=".concat(title, " ").concat(whatsappUrl),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WhatsappFilled.WhatsappFilled, {
        size: "medium",
        title: "Share Via Whatsapp"
      })
    })]
  });
};
ShareButtons.propTypes = {
  url: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired
};